import dayjs from 'dayjs';

import { File } from '@shared/components/file-manager/state/file.model';
import { listDocumentsQuery } from '@shared/services/gql.service';

import { EDCUploadStatus } from '../types/edc-status.type';

export function getEDCUploadStatusFromFiles(
  files: File[] | listDocumentsQuery['items']
): EDCUploadStatus {
  const item = { date_uploaded: 'not_date', uploaded_by: '' } as EDCUploadStatus;

  if (!files || files.length === 0) {
    return item;
  }

  const uploadedFiles =
    '__typename' in files[0]
      ? files
      : ((files as File[]).filter(
          (file) => file.uploaded && !!file.rawFile && !!file.create_date && !!file.created_by
        ) as File[]);

  if (!uploadedFiles.length) {
    return item;
  }

  const lastDatedFile = files.reduce((a, b) => {
    return dayjs(a.create_date).isAfter(b.create_date) ? a : b;
  });

  item.uploaded_by = lastDatedFile.created_by || '';
  item.date_uploaded = lastDatedFile.create_date || '';

  return item;
}
